import useRouteQueryParams from "../../../../../common/hooks/use-route-query-params";
import OrderOptimizerListingRouteQueryParams from "../../../common/routes/types/order-optimizer-listing-route-params";
import OrderOptimizerTaxiListingFilter from "../common/types/order-optimizer-taxi-listing-filter";
import orderOptimizerTaxiListingFiltersService from "./order-optimizer-taxi-listing-filters.service";

const useOrderOptimizerTaxiListingFiltersDao = () => {
  const [routeQueryParams, setRouteQueryParams] =
    useRouteQueryParams<OrderOptimizerListingRouteQueryParams>();

  const getPage = () => {
    return orderOptimizerTaxiListingFiltersService.getPage(routeQueryParams);
  };

  const getPageSize = () => {
    return orderOptimizerTaxiListingFiltersService.getPageSize(
      routeQueryParams
    );
  };

  const getFilters = (): OrderOptimizerTaxiListingFilter[] => {
    return orderOptimizerTaxiListingFiltersService.getFilters(routeQueryParams);
  };

  const saveFilters = (
    filters: OrderOptimizerTaxiListingFilter[],
    page: number,
    pageSize: number
  ): void => {
    const routeQueryParams =
      orderOptimizerTaxiListingFiltersService.createRouteQueryParams(
        filters,
        page,
        pageSize
      );

    setRouteQueryParams(routeQueryParams);
  };

  return {
    getPage,
    getPageSize,
    getFilters,
    saveFilters,
  };
};

export default useOrderOptimizerTaxiListingFiltersDao;
